/**
 * 动态根字号：1rem = 视口逻辑宽 / 10（375 宽时约 37.5px，与 postcss-pxtorem rootValue 一致）。
 * 宽度上限 480px，避免宽屏把 rem 放得过大。
 */
const APP_MAX_WIDTH_PX = 480
const ROOT_SPLIT = 10

export function setRemRoot () {
  if (typeof window === 'undefined' || !document.documentElement) return

  const vw = window.innerWidth || document.documentElement.clientWidth
  const w = Math.min(vw, APP_MAX_WIDTH_PX)
  const fs = w / ROOT_SPLIT
  document.documentElement.style.fontSize = `${fs}px`
}

export function initRemRoot () {
  setRemRoot()
  window.addEventListener('resize', setRemRoot)
  window.addEventListener('orientationchange', setRemRoot)
}
